import {useTranslation} from 'react-i18next';

import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';

import {DistributionBarItem, PercentageDistributionBars} from './PercentageDistributionBars';
import {surveyStatisticBars} from './SurveyStatisticBars.colors';
import {convertDataCountToPercentages} from '../../../../../../../utils/convertDataCountToPercentages/convertDataCountToPercentages';
import {Survey} from '../../../types/SurveyTypes';

interface Props {
  survey: Survey | undefined;
  isOmitted?: boolean;
}

export const LanguageDistributionBars = ({survey, isOmitted}: Props) => {
  const {t} = useTranslation();
  const isLanguagesOmitted = isOmitted ?? Boolean(survey?.configuration?.omitSpokenLanguage);

  const getItems = (): DistributionBarItem[] => {
    const statistics = survey?.statistics;
    if (!statistics) {
      return [];
    }

    const percentages = convertDataCountToPercentages({
      english: statistics.respondentsPerLanguage.en || 0,
      german: statistics.respondentsPerLanguage.de || 0,
      both: statistics.respondentsPerLanguage.both || 0,
    });

    return [
      {label: t('companySurveys.details.both'), percentage: percentages.both, color: surveyStatisticBars.language},
      {label: t('companySurveys.details.en'), percentage: percentages.english, color: surveyStatisticBars.language},
      {label: t('companySurveys.details.de'), percentage: percentages.german, color: surveyStatisticBars.language},
    ];
  };

  return (
    <PercentageDistributionBars
      title={t('companySurveys.details.languages')}
      icon={<TranslateOutlinedIcon sx={{fontSize: 14}} />}
      items={getItems()}
      isOmitted={isLanguagesOmitted}
    />
  );
};
